import axios from "axios";

const api = axios.create({
    baseURL: "/api",
    headers: {
        "Content-Type": "application/json",
    },
});

export const getAllArticles = async () => {
    return api.get("/articles/visibles");
}

export const getArticleById = async (id) => {
    return api.get(`/articles/${id}`);
}